import React, {useContext} from "react";
import classNames from "classnames";
import {useSelector} from "react-redux";
import {InvestigationDetailContext} from "contexts/InvestigationDetailContext";
import {RelationsGraphContext} from "contexts/RelationsGraphContext";
import {
  selectInvestigationEventsLoading,
  selectInvestigationGraphLoading
} from "store/selectors/investigationSelectors";
import InvestigationStatus from "./InvestigationStatus";
import LayoutSelectDropdown from "./LayoutSelectDropdown";
import TypeSelectDropdown from "./TypeSelectDropdown";

const InvestigationDetailToolbar = () => {
  const isLoading = useSelector(
    selectInvestigationGraphLoading || selectInvestigationEventsLoading
  );

  const {isSavedInvestigation} = useContext(InvestigationDetailContext);

  const {entityTypes, selectedTypes, setSelectedTypes, setLayout} = useContext(
    RelationsGraphContext
  );

  return (
    <div
      className={classNames("d-flex align-center ma-2")}
      data-testid={"InvestigationDetail-Toolbar"}>
      {/** Layout Selection */}
      <LayoutSelectDropdown setLayout={setLayout} disabled={isLoading} />

      {/** Type Selection */}
      <TypeSelectDropdown
        types={entityTypes}
        selectedTypes={selectedTypes}
        setSelectedTypes={setSelectedTypes}
        disabled={isLoading}
      />

      {!isSavedInvestigation && <InvestigationStatus />}
    </div>
  );
};

export default InvestigationDetailToolbar;
